export enum Case4CauseEnum {
  None = '',
  CASE4CAUSE = 'CASE4CAUSE',
  GRAPEFULCLUB = 'GRAPEFULCLUB',
}
